module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0080.jpg?v=884f8480";